var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from "classnames";
// A importer si on veut utiliser le DSFR, sinon on dev nous même
import "@gouvfr/dsfr/dist/component/form/form.css";
import "@gouvfr/dsfr/dist/component/input/input.css";
import "@gouvfr/dsfr/dist/component/button/button.css";
var Button = function (props) {
    var variant = props.variant, size = props.size, icon = props.icon, iconPosition = props.iconPosition, children = props.children, _a = props.disabled, disabled = _a === void 0 ? false : _a, className = props.className, remainingProps = __rest(props, ["variant", "size", "icon", "iconPosition", "children", "disabled", "className"]);
    var _className = classNames("fr-btn", "".concat(size ? "fr-btn--" + size : ""), "".concat(variant ? "fr-btn--" + variant : ""), "".concat(iconPosition ? "fr-btn--icon-" + iconPosition : ""), className);
    return (React.createElement(React.Fragment, null, iconPosition === "left" || iconPosition === "right" ? (React.createElement(React.Fragment, null, iconPosition === "left" ? (React.createElement("button", __assign({ className: _className, disabled: disabled }, remainingProps),
        React.createElement("span", { className: icon, "aria-hidden": "true" }),
        props.children)) : (React.createElement("button", __assign({ className: _className, disabled: disabled }, remainingProps),
        props.children,
        " ",
        React.createElement("span", { className: icon, "aria-hidden": "true" }))))) : (React.createElement("button", { className: _className, disabled: disabled }, children))));
};
export default Button;
